// Single source of truth for the app's supported UI locales.
//
// Lives in utils/ (NOT i18n/) on purpose: the embed bundle's services/api.js
// needs the supported-locale set for its Accept-Language whitelist, but the
// embed-bundle guard (tests/embedNoI18n.test.js) forbids embed files from
// importing anything under `../i18n` (it would pull petite-vue-i18n + the
// catalogs into the embed bundle). A plain constant module under utils/ is
// import-safe for both worlds and keeps the list from drifting between
// src/i18n/index.js (loaders) and services/api.js (Accept-Language).
//
// To ACTIVATE a new locale: add its code here, AND add a catalog loader in
// src/i18n/index.js + a PrimeVue locale in src/composables/useLocale.js (those
// reference real files, so they grow only once the files exist).
export const SUPPORTED_LOCALES = ['en', 'de', 'fr', 'es', 'pt', 'it']

// Language self-names for the in-app switcher — endonyms stay UNtranslated by
// convention (a German user hunting for English must be able to read it). Kept
// for every planned locale so the switcher options derive straight from
// SUPPORTED_LOCALES with no per-activation edit here.
export const LOCALE_ENDONYMS = {
  en: 'English',
  de: 'Deutsch',
  fr: 'Français',
  es: 'Español',
  pt: 'Português',
  it: 'Italiano'
}
